const { innerWidth, innerHeight } = window
const screenWidth = innerWidth < innerHeight ? innerWidth : innerHeight;
const screenHeight = innerWidth < innerHeight ? innerHeight : innerWidth;

const cellCountHorizontal = process.env.REACT_APP_GRID_WIDTH
const cellCountVertical = process.env.REACT_APP_GRID_HEIGHT

const isSmallScreen = screenWidth < 600
const isBigScreen = !isSmallScreen

let calculatedScreenWidth = 375
if (isSmallScreen) {
  calculatedScreenWidth = screenWidth - 5 - 5
}
const cellWidth = calculatedScreenWidth / cellCountHorizontal
const cellHeight = calculatedScreenWidth / cellCountVertical

const isSmallGrid = cellCountHorizontal <= 5
const isBigGrid = !isSmallGrid

const metrics = {
  screenWidth,
  screenHeight,
  isSmallScreen,
  isBigScreen,
  cellCountHorizontal,
  cellCountVertical,
  cellWidth,
  cellHeight,
  isSmallGrid,
  isBigGrid,
}

export default metrics
